import lodash from 'lodash';
import queryString from 'query-string';
import jQuery from 'jquery';
import axios from 'axios';
import Vue from 'vue';

window._ = lodash;

window.queryString = queryString;

window.$ = window.jQuery = jQuery;

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vue = Vue;

import VueLocalStorage from 'vue-localstorage';
window.Vue.use(VueLocalStorage);

import Helper from './src/core/Helper';
window.Helper = Helper;

import Reporter from './src/core/Reporter';
window.Reporter = new Reporter;

import EventHandler from './src/core/EventHandler';
window.EventHandler = new EventHandler;

import ViewPort from './src/core/ViewPort';
window.ViewPort = new ViewPort;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
